module.exports = __webpack_public_path__ + "static/fonts/iconfont.d1fe62e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/iconfont.woff?t=1589351592175
// module id = aWXf
// module chunks = 1